import { ButtonSize, Loader, State } from "@telusinternationalai/seibun-ui";
import { ReactElement } from "react";

export default function LoadingComponent({ title }: { title: string }): ReactElement {
  return (
    <div className="sui-h-96">
      <State icon={<Loader role="status" />} size={ButtonSize.MEDIUM} title={title} />
    </div>
  );
}
